import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'

import MaintenanceItem from './maintenanceitem/MaintenanceItem'

export default class MaintenanceItems extends PureComponent {
  static propTypes = {
    maintenanceItems: PropTypes.array.isRequired,
    onSelectMaintenanceItem: PropTypes.func.isRequired,
    selectedMaintenance: PropTypes.object,
    timeToScreen: PropTypes.func.isRequired,
    bollardToScreen: PropTypes.func.isRequired
  }

  render() {
    return (
      <div className="maintenance-items-wrapper">
        {this.props.maintenanceItems.map(maintenanceItem => {
          return (
            <MaintenanceItem
              key={maintenanceItem._id}
              terminalMaintenance={maintenanceItem}
              onSelectMaintenanceItem={this.props.onSelectMaintenanceItem}
              selectedMaintenance={this.props.selectedMaintenance}
              timeToScreen={this.props.timeToScreen}
              bollardToScreen={this.props.bollardToScreen}
            />
          )
        })}
      </div>
    )
  }
}
